<template>
  <el-scrollbar class="main-app">
    <div id="app">
      <!-- <img src="./assets/logo.png"> -->
      <div class="head-wrap">
        <div class="head-box">
          <div class="head-left-box">
            <div class="logo-wrap">
              <img src="./assets/logo1.png" alt="">
              <!--<span class="ml10">微景制作工具</span>-->
            </div>
            <div class="link-wrap">
              <div class="link-box">
                <router-link to='/pano/tasklist'>
                  全景制作
                </router-link>
              </div>
              <div class="link-box">
                <router-link to='/model/tasklist'>
                  三维重建
                </router-link>
              </div>
            </div>
          </div>
          <div class="downloadApp" @click="downApp">
            <img src="./assets/images/computer.svg" alt="">
            <span>客户端下载</span>
          </div>
          <template v-if='userInfo.isregister'>
            <div class="userInfo-wrap">
              <div class="user-box">
                <span class="el-dropdown-link">{{username && username.length > 20 ? username.substr(0,20) + '...' : username}}</span><span :class="paytypeIcon" style="display: inline-block;margin-left: 5px;vertical-align: middle;"></span><i class="el-icon-caret-bottom el-icon--right"></i>
                <div class="dropdown-list">
                  <div class="endTime">
                    <p class="mt15">{{payForMember[payType]}}</p>
                    <span v-if="!payType">升级用户获得更多权益</span>
                    <span v-if="payType && $store.state.userInfo.memberEndDate && $store.state.userInfo.memberEndDate !== 'null'">{{memberEndDate.date}}到期</span><span v-if="memberEndDate.dayNum > 0 && memberEndDate.dayNum < 30">，剩余{{memberEndDate.dayNum}}天</span><br>
                    <a v-if="!payType || memberEndDate.dayNum < 30" class="promote" @click="pay(1)">{{payType === 0 ? '升级' : '续费'}}</a>
                  </div>
                  <ul>
                    <li @click="pay(2)">
                      <a class="btn-nav">更多付费权益</a>
                    </li>
                    <li>
                      <a class="btn-nav logout" @click="logout">退出登录</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div @click="login" class="login-btn">登录</div>
          </template>
        </div>
      </div>
      <login ref="login"></login>
      <router-view></router-view>
    </div>
  </el-scrollbar>
</template>

<script>
import login from '@/components/loginDia'
import { shotUrl, showUrl, formatDate, env } from '@/filters'
export default {
  name: 'App',
  components: {
    login: login
  },
  created () {
  },
  data () {
    return {
      payForMember: {
        0: '免费账户',
        1: '基础账户',
        5: '高级账户'
      }
      // userName: this.$cookie.get('vizenName')
    }
  },
  computed: {
    paytypeIcon () {
      let paytypeIcon = ''
      switch (this.payType) {
        case 0:
          paytypeIcon = 'novip'
          break
        case 1:
          paytypeIcon = 'vip'
          break
        case 5:
          paytypeIcon = 'svip'
          break
      }
      return paytypeIcon
    },
    payType () {
      return this.$store.state.userInfo.payType // 会员等级
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    username () {
      return this.$store.state.userInfo.vizenName
    },
    // 会员等级到期时间 还剩多少天
    memberEndDate () {
      let obj = {
        date: this.$store.state.userInfo.memberEndDate * 1 || 0,
        dayNum: 0
      }
      if (obj.date && obj.date !== 'null') {
        let Newdate = new Date().getTime()
        obj.dayNum = parseInt((obj.date - Newdate) / (24 * 60 * 60 * 1000))
        obj.date = formatDate(obj.date, 'yyyy-MM-dd')
        obj.date = obj.date.split('-').join('.')
      }
      return obj
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!this.userName) {
        let params = {
          token: this.$route.query.token
        }
        this.$api.validationToken({params: params}).then(res => {
          if (res.code === '0') {
            this.$saveCookie(res.data)
          } else {
            this.$message.warning(res.msg)
          }
        })
      }
    })
  },
  methods: {
    downApp () {
      // 判断系统
      var agent = navigator.userAgent.toLowerCase()
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        if (env() === 'test') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-test-win-setup.exe'
        } else if (env() === 'online') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-release-win-setup.exe'
        }
      }
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        if (env() === 'test') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-test-win-setup.exe'
        } else if (env() === 'online') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-release-win-setup.exe'
        }
      }
      if (isMac) {
        if (env() === 'test') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-test-mac.dmg'
        } else if (env() === 'online') {
          window.location.href = 'https://cdtec-10002033.cos.ap-shanghai.myqcloud.com/download/materialuploader-v1.5.20200114-release-mac.dmg'
        }
      }
    },
    login () {
      this.$refs['login'].loginDia = true
    },
    logout () {
      this.$api.logout(this.userInfo.platformSource).then(res => {
        if (res.code === '0') {
          this.$cookie.delCookies()
          this.$store.commit('saveUserInfo', {})
          window.location.href = window.location.href
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    pay (type) {
      let host = shotUrl
      if (this.userInfo.platformSource === 1) {
        host = showUrl
      }
      let uri = '/joinMember/rights'
      if (type !== 1) {
        uri = '/joinMember/packbags'
      }
      let url = `${host}${uri}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
#app {
  // width: 1200px;
  // margin: 0 auto;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  & > * {
    width: 1200px;
    margin: 0 auto;
  }
  .head-wrap {
    width: 100%;
    height: 60px;
    background: #25282A;
    color: #ffffff;
    .head-box {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .downloadApp {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 120px;
        height: 60px;
        line-height: 60px;
        img {
          margin-top: 17px;
          margin-right: 5px;
        }
        span {
          position: relative;
          top: -6px;
        }
      }
      .head-left-box {
        display: flex;
        .logo-wrap {
          display: flex;
          align-items: center;
          font-size: 18px;
          img {
            width: 208px;
            height: 28px;
          }
        }
        .link-wrap {
          height: 60px;
          margin-left: 205px;
          font-size: 16px;
          color: #FFFFFF;
          display: flex;
          .link-box {
            width: 64px;
            margin-right: 60px;
            border-bottom: 3px solid rgba(0, 0, 0, 0);
            a {
              height: 60px;
              display: inline-block;
              font-size:16px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:rgba(255,255,255,0.5);
              line-height:60px;
            }
            .router-link-active {
              font-size:16px;
              font-family:PingFangSC-Medium;
              font-weight:500;
              color:rgba(255,255,255,1);
            }
          }
        }
      }
      .userInfo-wrap {
        height: 100%;
        padding-top: 20px;
        box-sizing: border-box;
        .user-box{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #999999;
          text-align: left;
          display: inline-block;
          position: relative;
          padding-left: 20px;
          height: 100%;
          cursor: pointer;
          i{
            font-size: 12px;
            color: #999;
          }
        }
        .user-box .dropdown-list{
          display: none;
          width: 182px;
          box-sizing: border-box;
          position: absolute;
          top: 45px;
          right: 0px;
          margin: 0;
          list-style: none;
          text-align: left;
          border: 1px solid #e5e5e5;
          background-color: #fff;
          line-height: 1;
          z-index: 999;
          ul {
            width: 152px;
            padding-left: 0;
            margin: auto;
          }
          .endTime {
            width: 152px;
            margin: 0 auto;
            border-bottom: 1px solid rgba(0,0,0,0.12);
            padding-bottom: 10px;
            padding-top: 15px;
            p {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: rgba(0,0,0,0.87);
              line-height: 22px;
              margin: 0;
            }
            span {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: rgba(0,0,0,0.38);
              line-height: 20px;
            }
            a.promote {
              margin-top: 5px;
              height: 22px;
              display: inline-block;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #1E88E5;
              line-height: 22px;
              border: none;
              padding: 0;
            }
          }
        }
        .user-box:hover .dropdown-list{
          display: block;
        }
        .user-box a{
          text-align: left;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: rgba(0,0,0,0.87);
          text-decoration: none;
          display: inline-block;
          width: 152px !important;
          padding: 10px 0;
          border-bottom: 1px solid rgba(0,0,0,0.12);
        }
        .user-box li:hover,
        .user-box .router-link-active{
          background: rgba(0,0,0,0.08);
        }
      }
      .login-btn {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue